import FeatImage01 from '../assets/wlcm.png'
import Dashboard1 from '../assets/dashboardone.png'
import Dashboard4 from '../assets/dashboardfour.png'
import Dashboard5 from '../assets/dashboardfive.png'
import Dashboard6 from '../assets/dashboardsix.png'
import Inventory1 from '../assets/add_product.png'
import Inventory2 from '../assets/edit_product.png'
import Inventory3 from '../assets/edit_product.png'
import Invoice1 from '../assets/Slide13.jpg'
import Invoice2 from '../assets/Slide15.jpg'
import Invoice3 from '../assets/Slide16.jpg'
import {  Carousel } from 'react-bootstrap'
import myvideo from './videos/mbs.mp4'
import VideoThumb from '../assets/wlcm.png'
import ModalVideo from './ModalVideo'
import pdf from './MBSManual.pdf'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
}
from 'mdb-react-ui-kit';
import { useState } from 'react'
import SignUp from '../auth/Signup'
export default function Zigzag() {
  const handleDownload = () => {
    // using Java Script method to get PDF file
    const pdfUrl = pdf
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "MBSManual.pdf"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  }
  const [startsignin,setstartsignin]=useState(false)
  const [basicModal, setBasicModal] = useState(false);
 
  const toggleOpen = () => {
   setBasicModal(!basicModal)
 };
    return (
      <section>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="py-12 md:py-20 border-t border-gray-800">
  
            {/* Section header */}
            <div className="inline-flex text-lg font-semibold py-1 px-3 m-2 text-white-600 bg-cyan-200 rounded-full mb-4" style={{color:"white"}}>Our Product Showcase</div>
            <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
           
              <div className="inline-flex text-sm font-semibold py-1 px-3 m-2 text-green-600 bg-green-200 rounded-full mb-4">Reach goals that matter</div>
              <h1 className="h2 mb-4" style={{color:"white"}} >Modern Billing Solutions</h1>
              <p  className="text-xl text-gray-400" style={{color:"green"}}>One product, unlimited solutions</p>
             
            </div>
            <div className='mb-5'>
            <ModalVideo
                thumb={VideoThumb}
                thumbWidth={924}
                thumbHeight="276"
                thumbAlt="Modal video thumbnail"
                video={myvideo}
                videoWidth={1920}
                videoHeight={780} />
            </div>
            <div className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center">
                  <div data-aos="fade-up" data-aos-delay="400">
                    <button style={{backgroundColor:"#5D3FD3",padding:"10px"}}
                     className="btn text-white bg-purple-600 hover:bg-purple-700 w-full mb-4 sm:w-auto sm:mb-0"
                     onClick={()=>{
                      toggleOpen();
                      setstartsignin(!startsignin)}}
                     >
                      Start free trial
                      </button>
                  </div>
                  <div data-aos="fade-up" data-aos-delay="600">
                  <button
          style={{backgroundColor:"#6A6D6E", padding:"10px"}}
          className="btn text-white bg-gray-700 hover:bg-gray-800 w-full sm:w-auto sm:ml-4"
          onClick={handleDownload}
        >Learn more</button>
                  </div>
                </div>
            {/* Items */}
            <div className="grid gap-20">
  
              {/* 1st item */}
              <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
              <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 md:order-1" data-aos="fade-up">
                {/* Image */}
                <Carousel  interval={5000}>
                  <Carousel.Item>
             
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={FeatImage01} width={540} height={405} alt="Features 01" />
           
                </Carousel.Item>
                <Carousel.Item>
              
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={Dashboard1} width={540} height={405} alt="Features 01" />
             
                </Carousel.Item>
                <Carousel.Item>
             
                <img className="max-w-full mx-auto md:max-w-none h-auto" src={Dashboard4} width={540} height={405} alt="Features 01" />
        
                </Carousel.Item>
                <Carousel.Item>
             
             <img className="max-w-full mx-auto md:max-w-none h-auto" src={Dashboard5} width={540} height={405} alt="Features 01" />
        
           </Carousel.Item>
           <Carousel.Item>
             
             <img className="max-w-full mx-auto md:max-w-none h-auto" src={Dashboard6} width={540} height={405} alt="Features 01" />
        
           </Carousel.Item>
                </Carousel>
                </div>
                {/* Content */}
                <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-right">
                  <div className="md:pr-4 lg:pr-12 xl:pr-16">
                    <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                    <h3 className="h3 mb-3" style={{color:"white"}}>Smooth User Experience</h3>
                    <p className="text-xl text-gray-400 mb-4">Creative and cutomised user experience for handling the informations and processing the data very smoothly.</p>
                    <ul className="text-lg text-gray-400 -mb-2">
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Customised User Experience</span>
                      </li>
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Easy to Navigate From One Page to another Page</span>
                      </li>
                      <li className="flex items-center">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Automatic Stock Management</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
  
              {/* 2nd item */}
              <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
                {/* Image */}
                <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 rtl" data-aos="fade-up">
                {/* Image */}
                <Carousel  interval={5000}>
                  <Carousel.Item>
             
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={Inventory1} width={540} height={405} alt="Features 01" />
           
                </Carousel.Item>
                <Carousel.Item>
              
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={Inventory2} width={540} height={405} alt="Features 01" />
             
                </Carousel.Item>
                <Carousel.Item>
             
                <img className="max-w-full mx-auto md:max-w-none h-auto" src={Inventory3} width={540} height={405} alt="Features 01" />
        
                </Carousel.Item>
             
        
                </Carousel>
                
                </div>
                {/* Content */}
                <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-left">
                  <div className="md:pl-4 lg:pl-12 xl:pl-16">
                    <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                    <h3 className="h3 mb-3" style={{color:"white"}}>Inventory Management</h3>
                    <p className="text-xl text-gray-400 mb-4" >Very Smooth and automated inventory Management system where you can maintain your stock.</p>
                    <ul className="text-lg text-gray-400 -mb-2">
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Add Product Very Smoothly to the inventory</span>
                      </li>
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Edit or View the Existing Product</span>
                      </li>
                      <li className="flex items-center">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Delete Unnecessary Products</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
  
              {/* 3rd item */}
              <div className="md:grid md:grid-cols-12 md:gap-6 items-center">
                {/* Image */}
                <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 md:order-1" data-aos="fade-up">
                <Carousel  interval={5000}>
                  <Carousel.Item>
             
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={Invoice1} width={540} height={405} alt="Features 01" />
           
                </Carousel.Item>
                <Carousel.Item>
              
                  <img className="max-w-full mx-auto md:max-w-none h-auto" src={Invoice2} width={540} height={405} alt="Features 01" />
             
                </Carousel.Item>
                <Carousel.Item>
             
                <img className="max-w-full mx-auto md:max-w-none h-auto" src={Invoice3} width={540} height={405} alt="Features 01" />
        
                </Carousel.Item>
             
        
                </Carousel>
                </div>
                {/* Content */}
                <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6" data-aos="fade-right">
                  <div className="md:pr-4 lg:pr-12 xl:pr-16">
                    <div className="font-architects-daughter text-xl text-purple-600 mb-2">More speed. Less spend</div>
                    <h3 className="h3 mb-3" style={{color:"white"}} >Automated Invoicing</h3>
                    <p className="text-xl text-gray-400 mb-4">We Provide Automated invoicing then you no need to worry about your product price and taxes.</p>
                    <ul className="text-lg text-gray-400 -mb-2">
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>Cutom Invoice Templates</span>
                      </li>
                      <li className="flex items-center mb-2">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>1 year Cloud Back-up of Invocies</span>
                      </li>
                      <li className="flex items-center">
                        <svg className="w-3 h-3 fill-current text-green-500 mr-2 shrink-0" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                        </svg>
                        <span>View and Delete Invocies</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
  
            </div>
            <MDBModal  open={basicModal} setOpen={setBasicModal} tabIndex='0'>
        <MDBModalDialog centered  size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle style={{justifyContent:"center"}}>Modern Software Solutions</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={()=>{
                toggleOpen();
                setstartsignin(!startsignin)
              }}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {
                startsignin?<SignUp />:null
              }
            
        </MDBModalBody>
        </MDBModalContent>
        </MDBModalDialog>
        </MDBModal>
          </div>
        </div>
      </section>
    )
  }